import type { VoidFunctionComponent } from 'react';

import Button from '../../../../../../generic/Button/Button';
import { BUTTON_SIZE, BUTTON_TYPE } from '../../../../../../generic/Button/button-constants';
import ButtonGroup from '../../../../../../generic/Button/ButtonGroup';
import TooltipButton from '../../../../../../generic/Button/TooltipButton';
import Flex from '../../../../../../generic/Flex';
import { icons } from '../../../../../../generic/Icon/icons';
import { Icon } from '../../../../../../generic/Icon/index';
import type { ReleaseGroupState } from '../../../hooks/useReleaseGroupState';

import styles from '../../ReleaseGroupsRevamp.module.less';

export type ReleaseGroupsSaveCancelButtonsProps = {
  onCancel: () => void;
  onSave: () => void;
  cancelButtonText?: string;
  saveButtonText: string;
  validationErrors: ReturnType<ReleaseGroupState['validate']>;
  isLoading?: boolean;
};

const ReleaseGroupsSaveCancelButtons: VoidFunctionComponent<ReleaseGroupsSaveCancelButtonsProps> = (props) => {
  const tooltipMessage = props.validationErrors.join(' ');

  return (
    <div className={styles.saveAndCancelButtons}>
      <ButtonGroup>
        <Button type={BUTTON_TYPE.SECONDARY} size={BUTTON_SIZE.LARGE} onClick={props.onCancel}>
          {props.cancelButtonText || 'Cancel'}
        </Button>
        <TooltipButton
          id="release-groups-header-save-button-tooltip"
          tooltip={tooltipMessage}
          size={BUTTON_SIZE.LARGE}
          onClick={props.onSave}
          isDisabled={props.validationErrors.length > 0 || props.isLoading}
        >
          {/*
          We're using a custom loading icon instead of a LoaderButton in order to utilize the TooltipButton generic
        */}
          <Flex gap={8} align="center">
            {props.saveButtonText}
            {props.isLoading && <Icon icon={icons.circleO} hasSpin />}
          </Flex>
        </TooltipButton>
      </ButtonGroup>
    </div>
  );
};

export default ReleaseGroupsSaveCancelButtons;
